import { render, staticRenderFns } from "./FormaPagamentoBadge.vue?vue&type=template&id=4a3cde57&scoped=true"
import script from "./FormaPagamentoBadge.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoBadge.vue?vue&type=script&lang=js"
import style0 from "./FormaPagamentoBadge.vue?vue&type=style&index=0&id=4a3cde57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3cde57",
  null
  
)

export default component.exports